export default __webpack_public_path__ + "static/media/Gilroy-Regular.f7f5960c.otf";